import React, { useState, useEffect } from "react";
import { Card, Form } from "@deere/ux.uxframe-react";
import RadioGroup from "../../components/RadioGroup";
import CheckGroup from "../../components/CheckGroup";
import { useDispatch, useSelector } from "react-redux";
import { CYBER_ERR_MSG, EMPTY_BODY, QUESTION_PROPRIETARY, SCBM_SECCIO_CODES } from "../../utils/surveyLiterals";
import { findAnswerIndex, updateAnswerInArray, removeQuestion, getNewCheckValueAnswer, getTranslation, containsCheckBoxAnswer, isCheckBoxAnswer } from "../../utils/utils";
import { updateSurveyAnswers, removeSurveyAnswer } from "../../redux/action/surveyAction";
import store from "../../redux/store";
import { useTranslation } from "react-i18next";
import "../../assets/css/Sections.css";
import { DebounceInput } from "react-debounce-input";

export default function CyberSecurityPage({ survey }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [checkSection, setCheckSection] = useState("");
  const surveyResponse = useSelector((state) => state.survey.surveyResponse);
  const [answers, setAnswers] = useState([]);
  const section = survey.sections.find((e) => e.code === SCBM_SECCIO_CODES.CS && e.active);
  const questions = section && section.questions ? section.questions : null;
  const propQuestion = questions && questions.find((e) => e.text === QUESTION_PROPRIETARY);
  let tmpAns = useSelector((state) => state.survey.surveyAnswers);

  const propComments = propQuestion ? (findAnswerIndex(propQuestion.id, tmpAns) >= 0 ? tmpAns[findAnswerIndex(propQuestion.id, tmpAns)].answer : "") : "";

  useEffect(() => {
    setAnswers([...store.getState().survey.surveyAnswers]);
    if (propComments !== "") {
      setCheckSection("checked");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [surveyResponse]);

  if (!survey) {
    return EMPTY_BODY;
  }
  if (questions === null) {
    return (
      <div>
        <p>{CYBER_ERR_MSG}</p>
      </div>
    );
  }

  const handleCheckChange = (e, idQuestion) => {
    updateCheckAnswer(e, idQuestion);
  };

  const updateAnswer = (e, questionId) => {
    updateAnswerInArray(questionId, answers, e.target ? e.target.value : e);
    dispatch(updateSurveyAnswers({ questionId: questionId, answer: e.target ? e.target.value : e }));
    setAnswers([...store.getState().survey.surveyAnswers]);
  };
  const updateCheckAnswer = (e, questionId) => {
    let newCheckValue = getNewCheckValueAnswer(questionId, answers, e);
    if (newCheckValue === null || newCheckValue === "" || newCheckValue === ",") {
      //Remove Question
      removeQuestion(questionId, answers);
      dispatch(removeSurveyAnswer(questionId));
    } else {
      //Update Question
      updateAnswerInArray(questionId, answers, newCheckValue);
      dispatch(updateSurveyAnswers({ questionId: questionId, answer: newCheckValue }));
    }
    setAnswers([...store.getState().survey.surveyAnswers]);
  };

  function createCheckSection(question) {
    if (question.idQuestionDepends) {
      let qIndex = findAnswerIndex(question.idQuestionDepends, answers);
      if (qIndex >= 0 && answers[qIndex].answer === question.idSelectionDependson.toString()) {
        return (
          <>
            <Form.Group className="mb-4 pl-4">
              {getTranslation(question, "text") !== "" && <Form.Label className="uxf-label">{getTranslation(question, "text")}</Form.Label>}
              <div>
                <CheckGroup
                  key={question.id}
                  checkSelections={question ? question.selections : []}
                  handleChange={handleCheckChange}
                  question={question}
                  currentChecked={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ""}
                  section={getTranslation(section, "description")}
                  checkedproprietary={checkSection}
                />
              </div>
            </Form.Group>
          </>
        );
      }
    } else {
      return (
        <>
          <Form.Group>
            {getTranslation(question, "text") !== "" && <Form.Label className="uxf-label">{getTranslation(question, "text")}</Form.Label>}
            <div>
              <CheckGroup
                key={question.id}
                checkSelections={question ? question.selections : []}
                handleChange={handleCheckChange}
                question={question}
                currentChecked={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ""}
                section={getTranslation(section, "description")}
                checkedproprietary={checkSection}
              />
            </div>
          </Form.Group>
        </>
      );
    }
  }

  function createTextArea(question) {
    let indx = findAnswerIndex(question.id, answers);
    if (question.idQuestionDepends && question.idQuestionDepends > 0) {
      let questionIndex = findAnswerIndex(question.idQuestionDepends, answers);
      let ans = questionIndex >= 0 ? answers[questionIndex].answer : null;
      let value = "";
      if (questionIndex >= 0 && isCheckBoxAnswer(ans) && containsCheckBoxAnswer(question.idSelectionDependson, ans)) {
        value = question.idSelectionDependson;
      } else if (questionIndex >= 0 && !isCheckBoxAnswer(ans)) {
        value = ans;
      }
      return value && value.toString() === question.idSelectionDependson.toString() ? (
        <Form.Group className="mb-4 pl-4">
          <Form.Label className="uxf-label">{getTranslation(question, "text")}</Form.Label>
          <DebounceInput
            required={!checkSection}
            element="textarea"
            rows="2"
            aria-describedby="textarea-text"
            className="form-control"
            debounceTimeout={300}
            onChange={(e) => updateAnswer(e, question.id)}
            value={indx >= 0 ? answers[indx].answer : ""}
            name={`${getTranslation(section, "description")}-${question.id}`}
          />
          <div className="invalid-feedback">{t("bs_required")}</div>
        </Form.Group>
      ) : null;
    } else {
      return (
        <Form.Group className="mb-4">
          <Form.Label className="uxf-label">{getTranslation(question, "text")}</Form.Label>
          <DebounceInput
            required={!checkSection}
            element="textarea"
            rows="2"
            aria-describedby="textarea-text"
            className="form-control"
            debounceTimeout={300}
            onChange={(e) => updateAnswer(e, question.id)}
            value={indx >= 0 ? answers[indx].answer : ""}
            name={`${getTranslation(section, "description")}-${question.id}`}
          />
          <div className="invalid-feedback">{t("bs_required")}</div>
        </Form.Group>
      );
    }
  }

  function createTitleText(question) {
    if (question.idQuestionDepends && question.idQuestionDepends > 0) {
      let questionIndex = findAnswerIndex(question.idQuestionDepends, answers);
      let ans = questionIndex >= 0 ? answers[questionIndex].answer : null;
      let value = "";
      if (questionIndex >= 0 && isCheckBoxAnswer(ans) && containsCheckBoxAnswer(question.idSelectionDependson, ans)) {
        value = question.idSelectionDependson;
      } else if (questionIndex >= 0 && !isCheckBoxAnswer(ans)) {
        value = ans;
      }
      return value && value.toString() === question.idSelectionDependson.toString() ? (
        <Form.Group className="pl-4">
          <Form.Label className="uxf-label">{getTranslation(question, "text")}</Form.Label>
        </Form.Group>
      ) : null;
    }
  }

  function createRadioSection(question) {
    return (
      <>
        <Form.Group>
          <Form.Label className="uxf-label">{getTranslation(question, "text")}</Form.Label>
          <div>
            <RadioGroup
              key={question.id}
              rgIndex={""}
              radioLabels={question ? question.selections : []}
              updateAnswer={updateAnswer}
              question={question}
              defaultValue={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ""}
              section={getTranslation(section, "description")}
              checkedProprietary={checkSection}
            />
          </div>
        </Form.Group>
      </>
    );
  }

  if (survey === null) {
    return <></>;
  }
  return (
    <>
      <Card>
        <Card.Body id={section ? section.description : ""}>
          <Card.Title className="pb-3 font-weight-bold">{getTranslation(section, "description")}</Card.Title>
          <>
            {
              <>
                {questions &&
                  questions
                    .sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))
                    .map((q, index) => (
                      <div key={index}>
                        <Form.Row className={q.idQuestionDepends ? "d-block mb-4 pl-4" : "d-block mb-4"}>
                          {q.type === "RADIO" && (q.dependentQuestions === "undefined" || q.dependentQuestions.length <= 0) ? createRadioSection(q) : <></>}
                          {q.type === "OPEN" && (q.dependentQuestions === "undefined" || q.dependentQuestions.length <= 0) ? createTextArea(q) : <></>}
                          {q.type === "CHECK" && (q.dependentQuestions === "undefined" || q.dependentQuestions.length <= 0) ? createCheckSection(q) : <></>}
                          {q.type === "OPEN_TITLE" && (q.dependentQuestions === "undefined" || q.dependentQuestions.length <= 0) ? createTitleText(q) : <></>}
                        </Form.Row>
                      </div>
                    ))}
              </>
            }
          </>
        </Card.Body>
      </Card>
    </>
  );
}
